<header>
  <img class="img-fluid" src="../../../assets/img/velmaral-banner.jpg" alt="logo">
</header>

<div class="container mt-4">

  <div class="card shadow-lg border-0">
    <h5 class="card-title mb-4 fw-bold text-center">
      பங்கேற்பாளர் விவரம் தேடல்
    </h5>
    <div class="card-body">
      <form [formGroup]="eventForm">
        <!-- ONE SINGLE ROW -->
        <div class="row g-3">

          <!-- EVENT SELECT -->
          <div class="col-md-6">
            <label class="form-label fw-bold">நிகழ்ச்சி பெயரை தேர்வு செய்யவும் <span
                class="text-danger">*</span><br>.</label>

            <select class="form-select" formControlName="eventId"
              [ngClass]="{'is-invalid': eventForm.get('eventId')?.touched && eventForm.get('eventId')?.invalid}">
              <option value="" disabled selected>-- நிகழ்ச்சியைத் தேர்வு செய்யவும் --</option>
              <option *ngFor="let event of eventDetails" [value]="event.eventId">
                {{ event.eventName }} - {{event?.city}}
              </option>
            </select>

            <div *ngIf="eventForm.get('eventId')?.touched && eventForm.get('eventId')?.invalid"
              class="text-danger mt-1 small">
              நிகழ்ச்சியை தேர்வு செய்யவும்.
            </div>
          </div>


          <!-- WHATSAPP NUMBER -->
          <div class="col-md-6">
            <label class="form-label fw-bold">பதிவு செய்யப்பட்ட வாட்ஸ்அப் / கைபேசி எண் (WhatsApp/Phone Number)<span
                class="text-danger">*</span></label>

            <input type="text" class="form-control" formControlName="whatsappNumber" maxlength="10"
              autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
              (input)="onPhoneInput($event,'whatsappNumber')" (keypress)="allowOnlyDigits($event)"
              (paste)="onPhonePaste($event,'whatsappNumber')"
              [ngClass]="{'is-invalid': eventForm.get('whatsappNumber')?.touched && eventForm.get('whatsappNumber')?.invalid}" />

            <div *ngIf="eventForm.get('whatsappNumber')?.touched && eventForm.get('whatsappNumber')?.invalid"
              class="text-danger mt-1 small">

              <span *ngIf="eventForm.get('whatsappNumber')?.errors?.['required']">
                வாட்ஸ்அப் எண் / கைபேசி எண் (WhatsApp / Phone Number)
              </span>

              <span *ngIf="eventForm.get('whatsappNumber')?.errors?.['pattern']">
                சரியான 10 இலக்க எண்ணை உள்ளிடவும்.
              </span>
            </div>
          </div>

        </div>

        <!-- SEARCH BUTTON -->
        <div class="text-center mt-4">
          <button class="btn btn-primary px-4 py-2 fw-bold" (click)="onSearch()">
            🔍 தேடல் (Search)
          </button>
        </div>

      </form>

    </div>
  </div>

</div>


<!-- <div class="ticket-wrapper" *ngIf="ticketDetails">

  <div class="image-container">

    <img src="assets/img/velmaral-event-qr.jpg" class="ticket-image" />

    <h4 class="name">{{ ticketDetails?.participantName }}</h4>

    <p class="name mt-5">{{ ticketDetails?.email }}</p>


    <img *ngIf="qrCodeImg" [src]="qrCodeImg" class="qrCode" />


    <p class="ticket">{{ ticketDetails?.groupTicketSeq }}</p>

  </div>
</div>-->

<div *ngIf="errorMessage" class="text-center mt-2">
  <div class="closed-wrapper" *ngIf="errorMessage">
    <div class="close-container">

      <div class="icon-circles">
        <i class="bi bi-x-circle-fill"></i>
      </div>

      <h5 *ngIf="errorMessage !== 'EVENT_NOT_REGISTERED'" class="tamil-title">நிகழ்வு முடிந்துவிட்டது</h5>
      <h5 *ngIf="errorMessage === 'EVENT_NOT_REGISTERED'" class="tamil-title">
        நீங்கள் இந்த நிகழ்ச்சியைப் பதிவு செய்யவில்லை
      </h5>
      <h6 class="tamil-text">நிகழ்வு ஏற்பாட்டாளரைத் தொடர்பு கொள்ளவும்.</h6>

      <hr />


      <h5 *ngIf="errorMessage !== 'EVENT_NOT_REGISTERED'" class="eng-title">
        Event Completed
      </h5>

      <h5 *ngIf="errorMessage === 'EVENT_NOT_REGISTERED'" class="eng-title">
        You have not registered for this event
      </h5>
      <h6 class="eng-text">Please contact the event organizer.</h6>

      <h5 class="contact">Contact Us: +91 7339663756</h5>

    </div>
  </div>

</div>

<mat-card class="order-card" *ngIf="this.getTicketDetails.length > 0">
  <h5 class="text-danger fw-bold text-center">Note:
    உங்கள் டிக்கெட்டை பார்க்க டிக்கெட் எண்ணை கிளிக் செய்யவும் (Click the ticket number to view your ticket)
  </h5>

  <div class="container-fluid">
    <div class="row">
      <mat-card-content>
        <div class="container-fluid mt-1">
          <div class="table-responsive table-style table-bordered">
            <table class="table table-gray table-head-fixed">
              <thead class="h6">
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Sub Participants Name</th>
                  <th>City</th>
                  <th>Phone Number</th>
                  <th>whatsApp Number</th>
                  <th>Email ID</th>
                  <th>Booked Date</th>
                  <th>Ticket Number</th>
                  <!-- <th>Payment Status</th>
                          <th>Payments Details</th> -->
                </tr>
              </thead>
              <tbody *ngIf="getTicketDetails.length > 0; else noDataFound">
                <tr class="text-center" *ngFor="let work of getTicketDetails | filter : searchText; let i = index;">
                  <td>{{ i + 1 }}</td>
                  <td>{{work?.name || "-"}}</td>
                  <td>
                    {{ getSubParticipantsNames(work?.audienceDetails) }}
                  </td>

                  <td>{{work?.district || "-"}}</td>
                  <td>{{work?.phoneNumber || "-"}}</td>
                  <td>{{ (work?.audienceDetails[0]?.whatsappNumber?.length > 2 ? work.whatsappNumber.slice(2) : work.whatsappNumber) || "-" }}</td>
                  <td>{{work?.emailId || "-"}}</td>
                  <td>{{work?.createdAt | date : "MM/dd/yyyy"}}</td>
                  <td>
                    <!-- <a [href]="getTicketUrl(work?.audienceDetails[0]?.ticketSeq)" target="_blank"
                      class="text-primary fw-bold" data-bs-toggle="tooltip" title="Click to view ticket"
                      class="text-primary" style="cursor:pointer; text-decoration: underline;"> -->

                      {{ work.audienceDetails[0]?.ticketSeq }}

                    <!-- </a> -->
                  </td>
                </tr>
              </tbody>
              <ng-template #noDataFound>
                <tr>
                  <td colspan="5" class="text-center fw-bold text-danger">Data Not Found</td>
                </tr>
              </ng-template>
            </table>
          </div>
        </div>
      </mat-card-content>
    </div>
  </div>
</mat-card>

<div class="row mt-5"></div>
<div class="row mt-5"></div>
<div class="row mt-5"></div>
<app-cktech-footer></app-cktech-footer>